/**
 * Calculates the average of an array of mood
 * @param {number[]} moods
 * @returns {number} The average mood value
 */
export default function mathAverage(moods) {
  const moodsCount = moods.length

  if (moodsCount === 0) {
    return null
  }

  const totalMood = moods.reduce((total, mood) => total + mood, 0.0)

  return totalMood / parseFloat(moodsCount)
}
